const PERFETTO_UI_ORIGIN = 'https://ui.perfetto.dev';

export interface OpenChromeTraceInPerfettoOptions {
  fileName: string;
  title?: string;
}

/** Opens a Chrome trace JSON string in https://ui.perfetto.dev/ via postMessage. */
export function openChromeTraceInPerfetto(
  traceJson: string,
  options: OpenChromeTraceInPerfettoOptions,
): void {
  const perfettoWindow = window.open(PERFETTO_UI_ORIGIN, '_blank');
  if (!perfettoWindow) {
    console.warn('[GameLoop] Could not open Perfetto UI — allow popups for this site.');
    return;
  }

  const buffer = new TextEncoder().encode(traceJson).buffer;
  const title = options.title ?? options.fileName;

  const pingTimer = window.setInterval(() => {
    perfettoWindow.postMessage('PING', PERFETTO_UI_ORIGIN);
  }, 100);

  const onMessage = (event: MessageEvent) => {
    if (event.source !== perfettoWindow || event.data !== 'PONG') {
      return;
    }

    window.clearInterval(pingTimer);
    window.removeEventListener('message', onMessage);
    perfettoWindow.postMessage(
      {
        perfetto: {
          buffer,
          title,
          fileName: options.fileName,
        },
      },
      PERFETTO_UI_ORIGIN,
    );
  };

  window.addEventListener('message', onMessage);
}
